module.exports = __webpack_public_path__ + "img/logo-no-text-white.7e7d3701.svg";